// extracted by mini-css-extract-plugin
export default {"richTextEditor":"language-editor_richTextEditor__7E666","editorsWrapper":"language-editor_editorsWrapper__dRpDk"};